module.exports = __webpack_public_path__ + "img/page.ba3b6a92.png";